import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "w-100 h-100 d-flex justify-content-center align-items-center"
}
const _hoisted_2 = {
  key: 1,
  class: ""
}

import { ref, provide } from "vue";
import SiderDetail from "@/components/SiderDetail2.vue";
import UserDocuments from "../modules/users/components/UserDocuments.vue";
import UserAccounts from "../modules/users/components/UserAccounts.vue";
import UserService from "../modules/users/services/UserService";
import { VerificationTypes } from "@/core/types/VerificationInfos";
import UserApplications from "../modules/users/components/UserApplications.vue";
import MsgPrompt from "@/core/plugins/MsgPrompt";
import UserWallets from "@/projects/tenant/modules/users/components/UserWallets.vue";
import UserPersonalInfos from "@/projects/tenant/modules/users/components/UserPersonalInfos.vue";
import UserRole from "@/projects/tenant/modules/users/components/userRole/UserRole.vue";
import UserContactInfo from "@/projects/tenant/modules/users/components/UserContactInfo.vue";
import UserConfig from "@/projects/tenant/modules/system/components/config/ConfigList.vue";
import PaymentInfo from "@/projects/tenant/modules/Payment/views/PaymentInformation.vue";
import UserDetailsHeader from "./UserDetails/UserDetailsHeader.vue";
import { ConfigCategory } from "@/core/types/ConfigCategory";
import UserApiLog from "@/projects/tenant/modules/users/components/UserApiLog.vue";
import UserVerifyCheck from "@/projects/tenant/modules/users/components/UserVerifyCheck.vue";
import ScaleLoader from "vue-spinner/src/ScaleLoader.vue";

enum UserDetailsType {
  infos = "infos",
  financial = "financial",
  documents = "documents",
  register = "register",
  accounts = "accounts",
  applications = "applications",
  paymentService = "paymentService",
  wallet = "wallet",
  paymentInfo = "paymentInfo",
  socialMedia = "socialMedia",
  config = "config",
  roles = "roles",
  apiLog = "apiLog",
  verifyCheck = "verifyCheck",
}


export default /*#__PURE__*/_defineComponent({
  __name: 'UserDetails',
  setup(__props, { expose: __expose }) {

const isLoading = ref(true);
const submitted = ref(true);

const userDetailShowRef = ref<InstanceType<typeof SiderDetail>>();

// default tab is documents
const tab = ref<UserDetailsType | string>(UserDetailsType.infos);
const partyId = ref(-1);
const userInfos = ref({} as any);
provide("userInfos", userInfos);
provide("partyId", partyId);
provide("tab", tab);
provide("UserDetailsType", UserDetailsType);

const verificationDetails = ref<any>(null);

const show = async (_partyId: number, defaultTab?: string) => {
  userDetailShowRef.value?.show();
  partyId.value = _partyId;
  await getUserInfos();
  await getUserVerificationDetails();
  tab.value = defaultTab ?? UserDetailsType.infos;
  submitted.value = false;
};

const onClose = () => {
  tab.value = UserDetailsType.infos;
};

const getUserInfos = async () => {
  try {
    isLoading.value = true;
    userInfos.value = await UserService.getUserInfoByPartyId(partyId.value);
  } catch (error) {
    MsgPrompt.error(error);
  } finally {
    isLoading.value = false;
  }
};

const getUserVerificationDetails = async () => {
  // 2. get user's verificationId
  isLoading.value = true;
  const res = await UserService.queryVerifications({
    type: VerificationTypes.Verification,
    partyId: partyId.value,
  });
  if (res.data.length === 0) {
    verificationDetails.value = null;
    isLoading.value = false;
    submitted.value = false;
    return;
  }
  const verificationId = res.data[0].id;

  // 3. get user's verification details by verificationId
  try {
    verificationDetails.value = await UserService.getVerificationById(
      verificationId
    );
  } catch (error) {
    MsgPrompt.error(error);
  } finally {
    isLoading.value = false;
  }
};

/**
 * fetch user account infos,
 * if there are pending applications,
 * we need to show the application dropdown list to fill the application form
 * else we need to show the account list with a button to add a new account
 *
 */

// once the user is approved, we need to show the account tab
// const onUserApproved = () => {
//   verificationDetails.value.status = VerificationStatusTypes.Approved;
//   tab.value = UserDetailsType.applications;
// };

__expose({ show });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SiderDetail, {
    title: _ctx.$t('title.userDetails') + ' - ' + partyId.value,
    width: "70%",
    direction: "ltr",
    ref_key: "userDetailShowRef",
    ref: userDetailShowRef,
    onClose: onClose
  }, {
    default: _withCtx(() => [
      (isLoading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(ScaleLoader, { color: '#ffc730' })
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(UserDetailsHeader),
            _createElementVNode("div", null, [
              _createElementVNode("div", null, [
                (tab.value === UserDetailsType.infos)
                  ? (_openBlock(), _createBlock(UserPersonalInfos, { key: 0 }))
                  : _createCommentVNode("", true),
                (tab.value === UserDetailsType.documents)
                  ? (_openBlock(), _createBlock(UserDocuments, {
                      key: 1,
                      verificationDetails: verificationDetails.value,
                      verifyOperation: false,
                      partyId: partyId.value,
                      onUpdateVerificationDetails: getUserVerificationDetails
                    }, null, 8, ["verificationDetails", "partyId"]))
                  : _createCommentVNode("", true),
                (tab.value === UserDetailsType.applications)
                  ? (_openBlock(), _createBlock(UserApplications, {
                      key: 2,
                      partyId: partyId.value,
                      onApplicationApproved: _cache[0] || (_cache[0] = ($event: any) => (tab.value = UserDetailsType.accounts))
                    }, null, 8, ["partyId"]))
                  : _createCommentVNode("", true),
                (tab.value === UserDetailsType.accounts)
                  ? (_openBlock(), _createBlock(UserAccounts, {
                      key: 3,
                      partyId: partyId.value
                    }, null, 8, ["partyId"]))
                  : _createCommentVNode("", true),
                (tab.value === UserDetailsType.wallet)
                  ? (_openBlock(), _createBlock(UserWallets, {
                      key: 4,
                      partyId: partyId.value
                    }, null, 8, ["partyId"]))
                  : _createCommentVNode("", true),
                (tab.value === UserDetailsType.paymentInfo)
                  ? (_openBlock(), _createBlock(PaymentInfo, {
                      key: 5,
                      partyId: partyId.value
                    }, null, 8, ["partyId"]))
                  : _createCommentVNode("", true),
                (tab.value === UserDetailsType.socialMedia)
                  ? (_openBlock(), _createBlock(UserContactInfo, {
                      key: 6,
                      partyId: partyId.value
                    }, null, 8, ["partyId"]))
                  : _createCommentVNode("", true),
                (tab.value === UserDetailsType.config)
                  ? (_openBlock(), _createBlock(UserConfig, {
                      key: 7,
                      rowId: partyId.value,
                      category: _unref(ConfigCategory).party,
                      siteId: userInfos.value.siteId
                    }, null, 8, ["rowId", "category", "siteId"]))
                  : _createCommentVNode("", true),
                (tab.value === UserDetailsType.roles)
                  ? (_openBlock(), _createBlock(UserRole, { key: 8 }))
                  : _createCommentVNode("", true),
                (tab.value === UserDetailsType.verifyCheck)
                  ? (_openBlock(), _createBlock(UserVerifyCheck, {
                      key: 9,
                      "verification-details": verificationDetails.value
                    }, null, 8, ["verification-details"]))
                  : _createCommentVNode("", true),
                (tab.value === UserDetailsType.apiLog && _ctx.$can('TenantAdmin'))
                  ? (_openBlock(), _createBlock(UserApiLog, {
                      key: 10,
                      partyId: partyId.value
                    }, null, 8, ["partyId"]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]))
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})